import { useState } from 'react';
import '../../index.scss';

const GetInTouch = () => {

    const [nome, setNome] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const sendWppMessage = () => {
        const mensagem = `${message} Atenciosamente, ${nome}, ${email}`
        
        const wpp = `https://api.whatsapp.com/send?phone=${+5531993624242}&text=${mensagem}`
        window.open(wpp, '_blank')
      }

    return (
        <section id="three" className="wrapper style1 fade-up">
            <div className="inner" id='GetInTouch'>
                <h2>Entre em contato</h2>
                <p>Entre em contato e solicite o seu orçamento. Escolha entre um dos nossos templates ou solicite uma personalização. Não perca tempo</p>
                <div className="split style1">
                    <section>
                        <form method="post" action="#">
                            <div className="fields">
                                <div className="field half">
                                    <label htmlFor="name">Name</label>
                                    <input type="text" name="name" id="name" value={nome} onChange={(ev) => setNome(ev.target.value)}/>
                                </div>
                                <div className="field half">
                                    <label htmlFor="email">Email</label>
                                    <input type="text" name="email" id="email" value={email} onChange={(ev) => setEmail(ev.target.value)}/>
                                </div>
                                <div className="field">
                                    <label htmlFor="message">Message</label>
                                    <textarea name="message" id="message" rows={5} value={message} onChange={(ev) => setMessage(ev.target.value)}></textarea>
                                </div>
                            </div>
                            <ul className="actions">
                                <li><span className="button submit" onClick={() => sendWppMessage()}>Enviar mensagem</span></li>
                            </ul>
                        </form>
                    </section>
                    <section>
                        <ul className="contact">
                            <li>
                                <h3>Email</h3>
                                <span>paulo.schaper+cyrkran@gmail.com</span>
                            </li>
                            <li>
                                <h3>Phone</h3>
                                <span>(31) 99362-4242</span>
                            </li>
                            <li>
                                <h3>Social</h3>
                                <ul className="icons">
                                    <li><a href="https://github.com/cyrkran" className="icon brands fa-github"><span className="label">GitHub</span></a></li>
                                    <li><a href="https://www.linkedin.com/in/paulo-schaper/" className="icon brands fa-linkedin-in"><span className="label">LinkedIn</span></a></li>
                                </ul>
                            </li>
                        </ul>
                    </section>
                </div>
            </div>
        </section>
    )
}

export default GetInTouch;